export class CharityModel {
    id: number;
    name: string;
    description: string;
    logoUrl: string;
}